import CustomApplicationState from "@sunSource/Store/CustomApplicationState";

export const getOnePageCheckoutTabState = (state: CustomApplicationState) => {
    return state?.sunSourceState?.OnePageCheckoutData?.tabState;
};

export const getOnePageCheckoutAccountState = (state: CustomApplicationState) => {
    return state?.sunSourceState?.OnePageCheckoutData?.createAccountState;
};
